<template>
  <div class="work">

    <!-- Header Area Start -->
    <AppHeader></AppHeader>

    <!-- Contents Area Start -->
    <div class="contents">
      <h2>Works</h2>

      <!-- g-menu -->
      <div class="g-menu">
        <ul>
          <li><a href="#" id="m1">All</a></li>
          <li><a href="#" id="m2">Graphic</a></li>
          <li><a href="#" id="m3">Website</a></li>
        </ul>
      </div>


      <!-- gallery -->
      <div class="grid" id="gallery">
        <ul>
          <li class="grid-item graphic">
            <a href="/dist/photo1@2x.png">
              <img src="../assets/images/photo1.png" alt="Photo1">
              <div class="caption">Project Name1</div>
            </a>
          </li>
          <li class="grid-item web">
            <a href="#popup1">
              <img src="../assets/images/photo2.png" alt="Photo2">
              <div class="caption">Project Name2</div>
            </a>
          </li>
          <li class="grid-item graphic">
            <a href="/dist/photo3.png">
              <img src="../assets/images/photo3.png" alt="Photo3">
              <div class="caption">Project Name1</div>
            </a>
          </li>
          <li class="grid-item web">
            <a href="#popup2">
              <img src="../assets/images/photo4.png" alt="Photo4">
              <div class="caption">Project Name2</div>
            </a>
          </li>
        </ul>
      </div>

    </div>

    <!-- Footer Area Start -->
    <AppFooter></AppFooter>


    <!-- Content Popup Area Start -->

    <!-- 첫번째 콘텐츠 팝업 -->
    <div id="popup1" class="white-popup mfp-hide">
      <h2>Popup Title1</h2>
      <p><img src="../assets/images/photo1@2x.png" alt="Big Photo1"></p>
      <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reprehenderit repellendus, hic alias distinctio accusantium facere repellat sapiente enim aliquam numquam at ex consequatur rerum totam autem quidem cum assumenda voluptate!</p>
      <p><a href="#" v-on:click="closePopup">[ 창 닫 기 ]</a></p>
    </div>


    <!-- 두번째 콘텐츠 팝업 -->
    <div id="popup2" class="white-popup mfp-hide">
      <h2>Popup Title2</h2>
      <p><img src="../assets/images/photo2@2x.png" alt="Big Photo2"></p>
      <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reprehenderit repellendus, hic alias distinctio accusantium facere repellat sapiente enim aliquam numquam at ex consequatur rerum totam autem quidem cum assumenda voluptate!</p>
      <p><a href="#" v-on:click="closePopup">[ 창 닫 기 ]</a></p>
    </div>


  </div>
</template>

<script>
import AppHeader from './component/Header.vue';
import AppFooter from './component/Footer.vue';

export default {
  name: "Work",
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    this.gallery();
    this.menuAct3();
  },
  methods: {

    gallery(){

      // Isotope 초기설정
      var grid = $('.grid');

      $(window).load(function(){
        $('.grid').isotope({
          // options
          itemSelector: '.grid-item',
          layoutMode: 'fitRows'
        });
      });


      // 매그니픽 팝업 초기설정
      // 1. 라이트박스 기능
      $('.graphic a').magnificPopup({
        type: 'image',
        gallery: {
          enabled: true
        }
      });

      // 2. 콘텐츠 팝업 기능
      $('.web a').magnificPopup({
        type: 'inline',
        closeBtnInside: true,   // 클로즈('X') 버튼 보이기
        closeOnBgClick: false,   // 배경클릭 창닫기 기능해제 
        gallery: {
          enabled: true
        }
      });



      // 필터링 버튼설정
      var m1 = $('#m1');     // all
      var m2 = $('#m2');     // graphic <= 라이트박스 팝업
      var m3 = $('#m3');     // web <= 콘텐츠 팝업

      m1.click(function(e){

        // 1. 정열기능
        grid.isotope({ 
          itemSelector: '.grid-item',
          layoutMode: 'fitRows',
          filter: '.grid-item'
        });

        // 2. 라이트박스 기능
        $('.graphic a').magnificPopup({
          type: 'image',
          gallery: {
            enabled: true
          }
        });

        // 3. 콘텐츠 팝업 기능
        $('.web a').magnificPopup({
          type: 'inline',
          closeBtnInside: true,   // 클로즈('X') 버튼 보이기
          closeOnBgClick: false,   // 배경클릭 창닫기 기능해제 
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();

      });

      m2.click(function(e){
        grid.isotope({ 
          itemSelector: '.grid-item',
          layoutMode: 'fitRows',
          filter: '.graphic'
        });

        $('.graphic a').magnificPopup({
          type: 'image',
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();
      });

      m3.click(function(e){
        grid.isotope({ 
          itemSelector: '.grid-item',
          layoutMode: 'fitRows',
          filter: '.web'
        });

        $('.web a').magnificPopup({
          type: 'inline',
          closeBtnInside: true,   
          closeOnBgClick: false,  
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();
      });

    },
    closePopup(e){
      $.magnificPopup.close();
      e.preventDefault();
    },
    menuAct3(){
      $('.footer a').removeClass('menu-act');
      $('.footer li:nth-child(3) a').addClass('menu-act');
    }

  }
}
</script>

<style lang="scss" scoped>

  @import '../sass/partials/_variable.scss';

  .work{

    // g-menu
    .g-menu{
      margin-bottom: 50px;

      li{
        display: inline-block;
        height: 40px;
        margin-right: 5px;

        a{
          display: block;
          height: 100%;
          padding: 0 15px;
          font: 1.6rem/40px $ff1;
          border: 1px solid #ccc;
          background-color: $bg-color3;
          
          :hover{
            background-color: $bg-color4;
          }
        }
      }
    }


    // gallery
    #gallery{
      li{
        width: 100%;
        height: auto;
        margin-bottom: 21px;
        position: relative;

        a{
          img{width: 100%;}

          .caption{
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            color: rgba(255, 255, 255, 0.7);
            position: absolute; left: 0; top: 0;
            font: 700 2.5rem $ff4;
            opacity: 0;

            -webkit-transition: all ease 0.6s;
            -moz-transition: all ease 0.6s;
            -o-transition: all ease 0.6s;
            transition: all ease 0.6s;
          }

          &:hover .caption{
            opacity: 1;
          }
        }

      }
    }


  }

</style>


// WEBPACK FOOTER //
// src/components/Works.vue